import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'button',
  props: {
  text: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'normal'
  }
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {


const props = __props

const emit = __emit
const handleClick = () => {
  emit('click')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.type == 'normal')
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "my-btn btn cursor-pointer",
          onClick: handleClick
        }, _toDisplayString(__props.text), 1))
      : _createCommentVNode("", true),
    (__props.type == 'form')
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "my-btn-form btn cursor-pointer",
          onClick: handleClick
        }, _toDisplayString(__props.text), 1))
      : _createCommentVNode("", true),
    (__props.type == 'step-form')
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "my-btn-step btn cursor-pointer",
          onClick: handleClick
        }, _toDisplayString(__props.text), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})